module.exports = __webpack_public_path__ + "images/bc999de95b84be92a5d8a66589b41c78.png";